import { UseMutateAsyncFunction } from '@tanstack/react-query';

import { useMutation, useQuery } from '@hooks/reactQuery';

import { auth } from '@store/selectors';
import { useAppSelector } from '@store/store';

import { getOrganisationMapSettings, updateOrganisationMapSettings } from '@api/organisationSettings';

import { extractQueryParams } from '@utils/common';

import { IClusterZoomLevelDTO, OrganisationMapSettingsDTO } from '@interfaces/map/dto/mapDTO';

import { ORGANISATION_MAP_SETTINGS } from '@constants/queryKeys';

export interface UseOrganisationMapSettings {
	mapOrganisationSettings: any;
	handleSetOrganisationMapSettings: UseMutateAsyncFunction<
		OrganisationMapSettingsDTO,
		any,
		IClusterZoomLevelDTO,
		any
	>;
}

export function useOrganisationMapSettings(): UseOrganisationMapSettings {
	const { accessPermission } = useAppSelector(auth);

	const { data } = useQuery({
		queryKey: [ORGANISATION_MAP_SETTINGS],
		queryFn: extractQueryParams(getOrganisationMapSettings),
		enabled: [accessPermission.networkOperatorOrganizationAdministrator],
	});

	const { mutateAsync } = useMutation<IClusterZoomLevelDTO, OrganisationMapSettingsDTO>({
		mutationKey: [ORGANISATION_MAP_SETTINGS],
		mutationFn: updateOrganisationMapSettings,
	});

	return {
		mapOrganisationSettings: data,
		handleSetOrganisationMapSettings: mutateAsync,
	};
}
